export default __webpack_public_path__ + "static/media/INSIDER_PAGES.1c85623d.png";